export const roleConstants = {
    "ROLE_LIST_REQUEST": "ROLE_LIST_REQUEST",
    "ROLE_LIST_SUCCESS": "ROLE_LIST_SUCCESS",
    "ROLE_LIST_FAILURE": "ROLE_LIST_FAILURE",
    "ROLE_LIST_REFRESH": "ROLE_LIST_REFRESH",
    "ROLE_LIST_CLEAR": "ROLE_LIST_CLEAR",

    "ROLE_BY_ID_SUCCESS": "ROLE_BY_ID_SUCCESS",
    "ROLE_BY_ID_FAILURE": "ROLE_BY_ID_FAILURE"
};
